<template>
  

  <v-select v-model="properties.tipologiapuntointeresse_id"
    @update:model-value="setLabel"
        label="Tipologia"
      :items="tipologie" 
      item-title="label"
    />


    <SegnalazioneCommon v-model="properties" />

    
</template>

<script setup>


import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import baseData from '@/assets/catalog/TrackerForms.json'
import { onMounted } from 'vue'

const properties = defineModel()

const props = defineProps({
  "isNew": {
    type: Boolean,
    default: false
  }
})

const tipologie = baseData.lookup.tipologiapuntointeresse


const loadDefaults = () => {
  properties.value.tipologiapuntointeresse_id =  tipologie[0].value
}



const setLabel = () => {
  const actualPunto = tipologie.find((item) => item.value == properties.value.tipologiapuntointeresse_id)
  if (actualPunto) {
    properties.value.label = actualPunto.label
  }
  else {
    properties.value.label = "Punto d'interesse"
  }
}



onMounted(() => {
  if (props.isNew) {
    loadDefaults()
    setLabel()
  }
})

</script>
